import {observable, action, runInAction} from 'mobx'
import {json, get} from '../../../utils/ajax'
import {handleSeerchAndPage, setStore, ValueObjToObj} from '../../../utils/Utils'
import {message} from "antd";

class DetailsOfNonLoadingPartsStore {

    @observable loading //数据加载
    @observable pagination //分页
    @observable searchFields //表单绑值
    @observable list //页面数据
    @observable importReturnData //存储导入返回值
    @observable showDrawer //开启导入数据抽屉
    @observable option //选择新增修改
    @observable forms //新增修改form
    @observable modal //新增修改模态框
    @observable hideOrShow //判断隐藏按钮
    @observable completedQuantity //已完成数量
    @observable unfinishedQuantity //未完成数量
    @observable unmatchedQuantity //未匹配数量

    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {}
        this.list = []
        this.importReturnData = []
        this.showDrawer = false
        this.option = ''
        this.forms = {}
        this.modal = false
        this.hideOrShow = 0
        this.completedQuantity = ''
        this.unfinishedQuantity = ''
        this.unmatchedQuantity = ''
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 页面初始化
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/queryListByPage`, search)
        const completedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/completed`)
        const unfinishedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/undone`)
        const unmatchedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/notMatched`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.hideOrShow = this.completedQuantity === completedQuantity ? 1 : 0
            this.completedQuantity = completedQuantity
            this.unfinishedQuantity = unfinishedQuantity
            this.unmatchedQuantity = unmatchedQuantity
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**开启导入返回数据抽屉**/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /**关闭导入返回数据抽屉**/
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**
     * 将页面的值绑到store
     * @param changedFields
     */
    @action
    onSearchFieldChange = (changedFields) => {
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /**
     * 重置
     * @returns {Promise<void>}
     */
    @action
    clearForm = async () => {
        this.searchFields = {}
        await this.initPage()
    }

    /**
     * 显示新增修改
     */
    @action
    showAddAndModify = async (defination, record) => {
        if (defination === 'update') {
            this.forms = {
                ...this.forms,
                ...record
            }
        }
        this.modal = true
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        this.forms = {...this.forms, ...ValueObjToObj(changedFields)}
    }

    /***新增、修改***/
    @action
    saveAddOrEditModal = async () => {
        this.loading = true
        if (this.option === '新增') {
            let search = {
                spareNo: this.forms.spareNo.value ? this.forms.spareNo.value : this.forms.spareNo,
                partCode: this.forms.partCode.value ? this.forms.partCode.value : this.forms.partCode,
                spareName: this.forms.spareName.value ? this.forms.spareName.value : this.forms.spareName,
                relatedItemNumber: this.forms.relatedItemNumber.value ? this.forms.relatedItemNumber.value : this.forms.relatedItemNumber
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/add`, search)
            if (!res.status) {
                message.warning('非装车件已存在！')
                this.loading = false
                return
            }
            message.success("新增成功")
            runInAction(() => {
                this.loading = false
                this.modal = false
            })
        } else {
            let search = {
                id: this.forms.id.value ? this.forms.id.value : this.forms.id,
                spareNo: this.forms.spareNo.value ? this.forms.spareNo.value : this.forms.spareNo,
                partCode: this.forms.partCode.value ? this.forms.partCode.value : this.forms.partCode,
                spareName: this.forms.spareName.value ? this.forms.spareName.value : this.forms.spareName,
                relatedItemNumber: this.forms.relatedItemNumber.value ? this.forms.relatedItemNumber.value : this.forms.relatedItemNumber
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/update`, search)
            if (!res.status) {
                message.warning('非装车件已存在！')
                this.loading = false
                return
            }
            message.success("修改成功")
            runInAction(() => {
                this.loading = false
                this.modal = false
            })
        }
        this.initPage(this.pagination.current)
    }

    /**
     * 刪除
     */
    @action
    deleteSparepartDefination = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/delById/id/${id}`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
        })
        await this.initPage(this.pagination.current)
    }

    /**
     * 处理
     */
    @action
    dealWith1 = async () => {
        await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/dealWith`)
    }

    /**
     * 处理
     */
    @action
    condition = async () => {
        runInAction(() => {
            this.loading = true
            this.hideOrShow = 1
            this.loading = false
        })
    }

    /**
     * 匹配数据
     */
    @action
    matchData = async () => {
        this.loading = true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/updateAssemblyIdToFileAssemblyTemp`)
        if (!res.status) {
            message.warning('匹配失败！')
            this.loading = false
            return
        }
        message.success("匹配完成")
        const completedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/completed`)
        const unfinishedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/undone`)
        const unmatchedQuantity = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/detailsOfNonLoadingParts/notMatched`)
        runInAction(() => {
            this.completedQuantity = completedQuantity
            this.unfinishedQuantity = unfinishedQuantity
            this.unmatchedQuantity = unmatchedQuantity
            this.loading = false
        })
    }
}

export default new DetailsOfNonLoadingPartsStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/DetailsOfNonLoadingParts/store.js